import http from "../http-common";

const getAll = (params) => {
  return http.get("/news", { params });
};

const get = (id) => {
  return http.get(`/news/${id}`);
};

const create = (data) => {
  return http.post("/news", data);
};

const update = (id, data) => {
  return http.put(`/news/${id}`, data);
};

const remove = (id) => {
  return http.delete(`/news/${id}`);
};

const removeAll = () => {
  return http.delete(`/news`);
};

const findByTitle = (title) => {
  return http.get(`/news?title=${title}`);
};

const News = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default News;
